class UnexpectedApiResponseError extends Error {
  constructor(httpCode: number) {
    super(`Unexpected HTTP Response with status code ${httpCode}`)
  }
}
export default UnexpectedApiResponseError
